export const en = {
  causes: {
    harm_reduction: 'Harm Reduction',
    crisis_support: 'Crisis Support',
    advocacy_and_human_rights: 'Advocacy & Human Rights',
    health_and_medecine: 'Health & Medecine',
    homeless_and_housing: 'Homeless & Housing',
    family_support: 'Family Support',
    employment_and_mentorship: 'Employment & Mentorship',
    disaster_and_emergency: 'Disaster & Emergency',
    international_development: 'International Development',
    food_security: 'Food Security',
    community: 'Community',
    bipoc: 'BIPOC',
    justice_and_legal: 'Justice & Legal',
    women: 'Women',
    stem: 'STEM',
    sports_and_recreation: 'Sports & Recreation',
    seniors: 'Seniors',
    mental_health: 'Mental Health',
    lgbtq: 'LGBTQ+',
    immigrants_and_refugees: 'Immigrants & Refugees',
    environment: 'Environment',
    education: 'Education',
    disabilities: 'Disabilities',
    children_and_youth: 'Children & Youth',
    board_development: 'Board Development',
    arts_and_culture: 'Arts & Culture',
    animals: 'Animals',
  },
}
